import axios from 'axios'
import config from './config'

export default {
  getSignedURL (file, organization_id) {

    let filepath = `${config.UPLOAD_FILEPATH_TEMPLATE}/${organization_id}/${file.name}`
    console.log("filepath in lambda is ", filepath)
    let endpoint = config.AWS_LAMBDA_GETSIGNEDURL_ENDPOINT
    let payload = {
      filePath: filepath,
      contentType: file.type
    }
    return axios.post(endpoint, payload)
      .then((res) => {
        console.log(JSON.stringify(res.data))
        return Promise.resolve(res.data || '/')
      })
      .catch((err) => {
        console.error(err)
        return Promise.reject('/')
      })
  }
}
